import {
  BusinessDistance,
  FinanceOption,
  ModelType,
  PrivateDistance,
} from '../../../../types';

export enum ImageTypeEnum {
  STUDIO = 'Studiobild',
  STUDIO_BG = 'Studiobild med bakgrund',
  EXTERIOR = 'Miljöbild',
}

export enum CarouselFieldsEnum {
  FROM_PRICE = 'Frånpris',
  PRIVATE_LEASING = 'Privatleasingpris',
  LOAN = 'Billån',
  BUSINESS_LEASE = 'Businesslease',
  BENEFICIAL_VALUE = 'Förmånsvärde',
  TAX = 'Fordonskatt',
  CTA_RETAILER = 'Kontakta återförsäljare',
  CTA_DISCOVER = 'Upptäck bilen',
  CHANGE_TRIM = 'Byt trim',
  CHANGE_DIRECTION = 'Byt riktning',
  PRIVATE_DESCRIPTION = 'Privatbeskrivning',
  COMPANY_DESCRIPTION = 'Företagsbeskrivning',
  TRIM_LEVEL_DESCRIPTION = 'Utrustningsbeskrivning',
  FEATURES = 'Trim-beskrivning',
  SHOW = 'Visa Filter',
  ALLOW_SORTING = 'Sortera',
}

export const sortableCarouselFields = [
  CarouselFieldsEnum.FROM_PRICE,
  CarouselFieldsEnum.PRIVATE_LEASING,
  CarouselFieldsEnum.BUSINESS_LEASE,
  CarouselFieldsEnum.BENEFICIAL_VALUE,
];

export type SortableCarouselField = (typeof sortableCarouselFields)[number];
export const descriptionFields = Object.values(CarouselFieldsEnum).filter(
  (value) => value.toLowerCase().includes('beskrivning'),
);

export const otherFields = Object.values(CarouselFieldsEnum).filter(
  (value) => !descriptionFields.includes(value),
);

export type CarouselOptions = {
  imageType?: ImageTypeEnum;
  fields?: CarouselFieldsEnum[];
};

export type BusinessEditionFilter = 'exclude' | 'include' | 'only';

type CarouselStore = {
  showPrivateMileages: boolean;
  businessEditionFilter: BusinessEditionFilter;
  models: ModelType[];
  filteredModels: ModelType[];
  currentHeading: string;
  direction: 'horizontal' | 'vertical';
  options: undefined | CarouselOptions;
  selectedFuels: number[];
  selectedCategories: number[];
  selectedFinanceOption: undefined | FinanceOption;
  selectedBusinessDistance: BusinessDistance;
  selectedPrivateDistance: PrivateDistance;
  isLoaded: boolean;
  sortField: SortableCarouselField | null;
  sortDirection: 'asc' | 'desc';
  dispatch: (args: CarouselAction) => void;
};

export interface HeadingAction {
  type: 'HEADING';
  payload: CarouselStore['currentHeading'];
}

export interface ImageTypeAction {
  type: 'IMAGE_TYPE';
  payload: CarouselOptions['imageType'];
}

export interface ControlsAction {
  type: 'CONTROLS';
  payload: CarouselOptions['fields'];
}

export interface DirectionAction {
  type: 'DIRECTION';
  payload: CarouselStore['direction'];
}

export interface ShowPriceListAction {
  type: 'SHOW_PRICELIST';
  payload: boolean;
}

export interface ShowPrivateMileagesAction {
  type: 'SHOW_PRIVATE_MILEAGES';
  payload: boolean;
}

export interface SetBusinessEditionFilter {
  type: 'SET_BUSINESS_EDITION_FILTER';
  payload: BusinessEditionFilter;
}

export interface ModelsAction {
  type: 'MODELS';
  payload: ModelType[];
}

export interface FilteredModelsAction {
  type: 'FILTERED_MODELS';
  payload: ModelType[];
}

export interface FuelAction {
  type: 'FUEL';
  payload: number[];
}

export interface CategoryAction {
  type: 'CATEGORY';
  payload: number[];
}

export interface FinanceOptionAction {
  type: 'FINANCE_OPTION';
  payload: FinanceOption;
}

export interface BusinessDistanceAction {
  type: 'BUSINESS_DISTANCE';
  payload: BusinessDistance;
}

export interface PrivateDistanceAction {
  type: 'PRIVATE_DISTANCE';
  payload: PrivateDistance;
}

export interface FilterModelsAction {
  type: 'FILTER_MODELS';
}

export interface IsLoadedAction {
  type: 'IS_LOADED';
  payload: boolean;
}
export interface SortByAction {
  type: 'SORT_BY';
  payload: SortableCarouselField;
  sortBy: 'asc' | 'desc';
}

const buttonClasses =
  'bg-white shadow-sm border whitespace-nowrap rounded-full py-1 px-4 text-gray-500 text-xs border-b-2 border-gray-500';
const activeButtonClasses = '!text-black border-b-4 !border-black';

export type CarouselAction =
  | HeadingAction
  | ImageTypeAction
  | ControlsAction
  | DirectionAction
  | ShowPriceListAction
  | ModelsAction
  | FilteredModelsAction
  | FuelAction
  | FinanceOptionAction
  | BusinessDistanceAction
  | FilterModelsAction
  | IsLoadedAction
  | CategoryAction
  | PrivateDistanceAction
  | ShowPrivateMileagesAction
  | SetBusinessEditionFilter
  | SortByAction;

export { activeButtonClasses, buttonClasses, CarouselStore };
